import { render, staticRenderFns } from "./BestellungRow.vue?vue&type=template&id=33d9014d"
import script from "./BestellungRow.vue?vue&type=script&lang=ts"
export * from "./BestellungRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports